(function() {
    'use strict';

    angular
        .module('fileUploadApp')
        .controller('UserManagementUploadController', UserManagementUploadController);

    UserManagementUploadController.$inject = ['$rootScope', '$state', '$timeout', '$uibModalInstance', '$scope','Upload','AlertService'];

    function UserManagementUploadController ($rootScope, $state, $timeout, $uibModalInstance, $scope, Upload,AlertService) {
        var vm = this;

        vm.authenticationError = false;
        //vm.startBulkUpload = startBulkUpload;
        //vm.myFile = null;
        vm.cancel = cancel;
        vm.uploadFile = uploadFile;
        vm.startBulkUpload = startBulkUpload;
        
        
        function cancel(){
        	$uibModalInstance.dismiss('cancel');
        }
        
        function startBulkUpload (file, url) {
        	if(file.name.toUpperCase().indexOf('.XLS') < 0) {
        		toastr.error("Cannot upload this file. Check that this is a proper excel file and try again.");
        		return;
            }
        	
        	
        	var uploadUrl = url;
        	
        	
            file.upload = Upload.upload({
                url: uploadUrl,
                //data: {username: "test", file: file},
                data: {file: file}
            });
            
            file.upload.then(function (response) {
                $timeout(function () {
                  //file.result = response.data;
                  if(response.status == '200') {
              		if(response.data.success == 'true') {
              			toastr.success("Uploaded file with " + response.data.count + " item(s).");
                  		//$scope.closeBulkUpload();
              			vm.cancel();
              			$rootScope.$emit('userUploaded');
              		}
              		else {
              			AlertService.add({
              				type: "danger",
              				msg: "Upload failed. Message: "+response.data.message,
              				timeout: 60000
              			})
              			vm.cancel();
              			$rootScope.$emit('userUploaded');
              		}
              	}else {
            		toastr.error("Cannot upload this file. Check that this is a proper excel file and try again.");
            	}
                  
                });
              }, function (response) {
                if (response.status > 0)
                  $scope.errorMsg = response.status + ': ' + response.data;
              }, function (evt) {
                // Math.min is to fix IE which reports 200% sometimes
                file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });
        	
        	/*
        	fileUpload.uploadFileToUrl(file, $scope.vendorId, uploadUrl, function(response) {
            	if(response.status == '200') {
            		if(response.data.success == 'true') {
            			toastr.success("Uploaded file with " + response.data.count + " item(s).");
                		$scope.closeBulkUpload();
            		}
            		else {
            			AlertService.add({
            				type: "danger",
            				msg: "Upload failed. Message: "+response.data.message,
            				timeout: 60000
            			})
            		}
            	}
            	else {
            		toastr.error("Cannot upload this file. Check that this is a proper excel file and try again.");
            	}
            });
            */
        };
        
        function uploadFile() {
            var file = $scope.myFile;
            console.log(vm.test);
            console.log(file);
            
            if (file) {
            	//var skipUser = file.skipDuplicateUser ? "?skipDuplicateUser=true" : ""
            	//var uploadUrl = "api/account/bulkUpload"+skipUser;
            	var uploadUrl = "api/account/bulkUpload";
            	vm.startBulkUpload(file, uploadUrl);
            }
            
        };
    }
})();
